/*
*###############################################################################
*Module Name                   : TransactionVDet.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  T A C Priyashad                              #
*Date                          : Thursday, October 14th 2021, 10:08:02 am      #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/
import React, { useState, useEffect } from "react"
import { Row, Col, Button, Label, Card, CardBody, CardTitle, Modal, ModalFooter, Alert } from "reactstrap"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPAlert from "../../../framework/widgets/DPAlert"
import DPDropDown from "framework/components/DPDropDown"
import { Text, Numeric } from "../../../framework/validators/TextValidation" // Textbox input validations
import DPSearchBoxDynamic from 'framework/components/DPSearchBoxDynamic'
import { getProductDetailsCode, getLineDicTotal, getProductDetailsCodeSuppWise, transOBJ, GetDetailReasonTypes, getTxnProductPricemode } from "../Transaction/TransactionController"
import ReactPaginate from "react-paginate"
import { Context } from "app-contexts/CommonContexts"
import { useContext } from "react"



const TransactionVDet = ({
    menuName,
    InvDataRow,
    DataRow,
    SetDataRow,
    TxnTotalCal,
    RefDataRow,
    AddRow,
    RemoveRow,
    BookChange,
    SupplierCode,
    blDiasableGrid,
    lineDisc,
    SetGrossTotaltx,
    SetLineDisc,
    SetTxNetAmount,
    GrossTotal,
    type,
    txn,
    supplierSelect,
    loccode,
    TaxDetails,
    taxTable,
    SetTaxtTable,
    DisableDet,
    menuCode,
    setDataForRecovery,
    RemoveRemDetRow,
    Reason,
    setReason,
    setPermissionAlertShow,
    setAlertConfirmOption,
    AlertConfirmOption,
    isOpen,
    toggle,
    mainTitle,
    SubTitle,
    Details,
    ProdCode,
    CalculateVariantItemsTax,
    priceModeSelect,
    ToLocation
}) => {


    const [txnUI, setTxnUI] = useState([]);
    const [prefixwidth, setPrefixWidth] = useState(0)
    const [autoScan, SetAutoScan] = useState(false)
    const authToken = localStorage.getItem("authToken")
    const [page, setPage] = useState(1)
    const [AlertMsg, SetAlertMsg] = useState('')
    const [AlertColor, SetAlertColor] = useState('')
    const [show, setShow] = useState(false)
    //const [taxTable, SetTaxtTable] = useState([])


    //* Column Width Lenth Setting */
    const [procode, setProCode] = useState({ name: "", len: 0, width: 0 })
    const [stkcode, setStkCode] = useState({ name: "", len: 0, width: 0 })
    const [prodesc, setProDesc] = useState({ name: "", len: 0, width: 0 })
    const [prounit, setProUnit] = useState({ name: "", len: 0, width: 0 })
    const [proexpdate, setProExpDate] = useState({ name: "", len: 0, width: 0 })
    const [procost, setProCost] = useState({ name: "", len: 0, width: 0 })
    const [prosell, setProSell] = useState({ name: "", len: 0, width: 0 })
    const [proweightavg, setProWeightAvg] = useState({ name: "", len: 0, width: 0 })
    const [prossell, setProSSell] = useState({ name: "", len: 0, width: 0 })
    const [propackprice, setProPackPrice] = useState({ name: "", len: 0, width: 0 })
    const [probalqty, setProBalQty] = useState({ name: "", len: 0, width: 0 })
    const [procs, setProCS] = useState({ name: "", len: 0, width: 0 })
    const [prosih, setProSIH] = useState({ name: "", len: 0, width: 0 })
    const [procaseqty, setProCaseQty] = useState({ name: "", len: 0, width: 0 })
    const [prouniteqty, setProUnitQty] = useState({ name: "", len: 0, width: 0 })
    const [profreeunit, setProFreeUnit] = useState({ name: "", len: 0, width: 0 })
    const [profreecase, setProFreeCase] = useState({ name: "", len: 0, width: 0 })
    const [prodiscper, setProDiscPer] = useState({ name: "", len: 0, width: 0 })
    const [prodiscamt, setProDiscAmt] = useState({ name: "", len: 0, width: 0 })
    const [proamt, setProAmt] = useState({ name: "", len: 0, width: 0 })
    const [proremark, setProRemark] = useState({ name: "", len: 0, width: 0 })
    const [chageTax, setChangeTax] = useState([])
    const [reasonTypes, SetReasonType] = useState([])
    const [VDataRow, SetVDataRow] = useState([])
    //* End Column Width Lenth Setting */

    useEffect(async () => {

        if (!isOpen) {
            return
        }

        const ApiURL = window.Links.ApiURL

        var requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`
            },
            redirect: 'follow'
        };

        fetch(`${ApiURL}txn/ui/${type}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                setTxnUI(result.data)
                let prefix = 10;
                let dat = result.data
                dat.map((r) => {
                    //debugger;
                    prefix = prefix + parseInt(r.strColWidth)
                    if (r.strColTblName == 'DET_PROCODE') {
                        setProCode({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_STOCKCODE') {
                        setStkCode({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_PRODESC') {
                        setProDesc({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_UNIT') {
                        setProUnit({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_SYSQTY') {
                        setProSIH({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_CS') {
                        setProCS({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_EXPDATE') {
                        setProExpDate({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_CPRICE') {
                        setProCost({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_SPRICE') {
                        setProSell({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_BALQTY') {
                        setProBalQty({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_CASEQTY') {
                        setProCaseQty({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_UNITQTY') {
                        setProUnitQty({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_FUNITQTY') {
                        setProFreeUnit({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_FCASEQTY') {
                        setProFreeCase({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_DISCPER') {
                        setProDiscPer({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_DISCAMT') {
                        setProDiscAmt({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_AMOUNT') {
                        setProAmt({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }
                    else if (r.strColTblName == 'DET_REMCODE') {
                        setProRemark({ name: r.strColTblName, len: parseInt(r.strColLen), width: parseInt(r.strColWidth) })
                    }

                })
                setPrefixWidth(prefix)
            }).catch(error => console.log('error', error));


    }, [isOpen])

    useEffect(async () => {

        SetDataToDetailTable(InvDataRow)

    }, [isOpen]);

    useEffect(() => {
        // debugger;
        let objTax = []
        for (let i = 0; i < taxTable.length; i++) {
            let drM = taxTable[i];
            if (objTax.length > 0) {
                for (let x = 0; x < objTax.length; x++) {
                    let dr = objTax[x];
                    if (drM.proCode == dr.proCode && drM.taxtCode == dr.taxtCode) {
                        objTax[x] = { proCode: dr.proCode, proDesc: dr.proDesc, taxRate: dr.taxRate, taxInclusive: dr.taxInclusive, grossAmt: (dr.grossAmt) + (drM.grossAmt), taxtCode: dr.taxtCode, taxDesc: dr.taxDesc, taxtDispRate: dr.taxtDispRate }
                        break;
                        //{ proCode: dr.strTDET_PROCODE, proDesc: FormRow.strDET_PRODESC, taxRate: dr.dcTDET_TAXRATE, taxInclusive: (!dr.blTDET_TAXINC), grossAmt: FormRow.dcDET_AMOUNT, taxtCode: dr.strTDET_TAXCODE, taxDesc: dr.strTDET_TAXCODE, taxtDispRate: dr.dcTDET_TAXRATE }
                    } else {
                        if (x == objTax.length - 1) {
                            objTax = objTax.concat({ proCode: drM.proCode, proDesc: drM.proDesc, taxRate: drM.taxRate, taxInclusive: drM.taxInclusive, grossAmt: drM.grossAmt, taxtCode: drM.taxtCode, taxDesc: drM.taxDesc, taxtDispRate: drM.taxtDispRate })
                            break;
                        }
                    }
                }
            } else {
                objTax = objTax.concat({ proCode: drM.proCode, proDesc: drM.proDesc, taxRate: drM.taxRate, taxInclusive: drM.taxInclusive, grossAmt: drM.grossAmt, taxtCode: drM.taxtCode, taxDesc: drM.taxDesc, taxtDispRate: drM.taxtDispRate })
            }
        }
        //SetTaxtTable(objTax)
    }, [chageTax])

    const SetDataToDetailTable = (data) => {

        var searchData = [];

        let DetTbl = DataRow.filter(X => X.strDET_PROCODE != "")

        // let lastID = DetTbl.length == 0 ? 1 : DetTbl[DetTbl.length - 1].id // get detail table last item id

        // Get the maximum `id` from the array
        let maxID = DetTbl.length > 0 ? Math.max(...DetTbl.map(item => item.id)) : 0;

        // Generate the new `id`
        let newID = maxID + 1;

        if (data.length > 0) {
            data.map(r => {
                searchData.push(SetDataVTable(r, newID))
                newID = newID + 1
            })
            SetVDataRow(searchData)

        } else {

        }
    }

    const SetDataVTable = (r, lastID) => {
        return {
            "strDET_TYPE": type,
            "strDET_COMCODE": "000",
            "strDET_RUNNO": "000",
            "strDET_LOCCODE": "000",
            "strDET_SACODE": "",
            "strDET_PROCODE": r.strProductCode,
            "strDET_STOCKCODE": r.strStockCode,
            "strDET_PRODESC": r.strProductDesc,
            "strDET_PROCOLOR": r.variant1,
            "strDET_PROSIZE": r.variant2,
            "strDET_UNIT": r.strUnitDesc,
            "dcDET_CS": r.dbCaseSize != 0 ? r.dbCaseSize : 1,
            "dtDET_EXPCHECK": r.isExp,
            "dtDET_EXPDAET": "1900-01-01",
            "strDET_EXPBATCH": "",
            "dcDET_SYSQTY": r.dbSIH,
            "dcDET_CASEQTY": 0,
            "dcDET_UNITQTY": 0,
            "dcDET_FCASEQTY": 0,
            "dcDET_FUNITQTY": 0,
            "dcDET_BALQTY": 0,
            "dcDET_FBALQTY": 0,
            "dcDET_VARQTY": 0,
            "dcDET_OSPRICE": r.dbSelling,
            "dcDET_OCPRICE": r.dbCost,
            "dcDET_OAPRICE": r.dbAvgCost,
            "dcDET_SPRICE": r.dbSelling,
            "dcDET_CPRICE": r.dbCost,
            "dcDET_ACOST": r.dbAvgCost,
            "dcDET_APRICE": r.dbAvgCost,
            "dcDET_DISCPER": 0,
            "dcDET_DISCAMT": 0,
            "dcDET_AMOUNT": 0.00,
            "strDET_REMCODE": "",
            "variant_ENABLE": true,
            "disable": true,
            "dcDET_SPRICE_OLD": r.dbSelling,
            "dcDET_CPRICE_OLD": r.dbCost,
            "isDecimal": r.isDecimal,
            "id": lastID,
            "openItem": 0,
            "innerCS": r.innerCaseSizesList,
            "defaultCS": r.dbCaseSize != 0 ? r.dbCaseSize : 1,
            "fixGP": r.dbFixGp,
        }
    }

    const LabelFilter = (priceMode) => {
        if (priceMode == 'C' || priceMode == 'c') {
            return (
                <th style={{ textAlign: "center", width: procost.width, WebkitTransform: 'rotate(315deg)' }} title="Cost Price">Cost</th>
            )
        } else if (priceMode == 'S' || priceMode == 's') {
            return (
                <th style={{ textAlign: "center", width: prosell.width, WebkitTransform: 'rotate(315deg)' }} title="Selling Price">Sell</th>
            )
        } else if (priceMode == 'A' || priceMode == 'a') {
            return (
                <th style={{ textAlign: "center", width: proweightavg.width, WebkitTransform: 'rotate(315deg)' }} title="Weighted Average">Weight.Avg.</th>
            )
        } else if (priceMode == 'P' || priceMode == 'p') {
            return (
                <th style={{ textAlign: "center", width: propackprice.width, WebkitTransform: 'rotate(315deg)' }} title="Pack/Case Price">Pack Price</th>
            )
        }
    }

    const TxnDet = () => {
        const mainGridItems = DataRow.filter((item) => item.strDET_PROCODE !== '' && item.strDET_PRODESC !== '');
        const variantSelectedItems = VDataRow.filter((item) => {
            if ((txn.intTX_FREEQTYMINUS == 1 || txn.intTX_VERIFICATION == 1) && txn.intTX_BOM == 0) {
                return item.dcDET_UNITQTY > 0 || item.dcDET_CASEQTY > 0 || Math.abs(item.dcDET_FUNITQTY) > 0
            } if (txn.intTX_CHANGEPRICE == 1) {
                return item.dcDET_OCPRICE != item.dcDET_CPRICE || item.dcDET_OSPRICE != item.dcDET_SPRICE
            } else {
                return item.dcDET_UNITQTY > 0 || item.dcDET_CASEQTY > 0
            }
        });

        if (txn.intTX_PLUREPEAT == 0) {
            const foundItem = variantSelectedItems.find((item) =>
                mainGridItems.some((mainItem) => mainItem.strDET_STOCKCODE == item.strDET_STOCKCODE)
            );

            if (foundItem) {
                const alertMsg = `Item ${foundItem.strDET_STOCKCODE} is already in the main grid. Cannot add the same item again.`;
                SetAlertMsg(alertMsg);
                SetAlertColor('danger');
                setShow(true);
                setTimeout(() => {
                    setShow(false);
                }, 10000);
                return;
            }
        }

        if (txn.strTX_REFTYPES != "" && txn.strTX_REFTYPES != null && RefDataRow.length > 0) {

            const isAllItemsInRefData = variantSelectedItems.every((item) => RefDataRow.some((refItem) => refItem.strDET_PROCODE == item.strDET_PROCODE && refItem.strDET_STOCKCODE == item.strDET_STOCKCODE));

            if (!isAllItemsInRefData) {
                const alertMsg = 'Some of the items are not in the reference data table. Please check the items and try again.';
                SetAlertMsg(alertMsg);
                SetAlertColor('danger');
                setShow(true);
                setTimeout(() => {
                    setShow(false);
                }, 10000);
                return;
            }

        }

        // let lastID = mainGridItems.length == 0 ? 1 : mainGridItems[mainGridItems.length - 1].id;
        let lastID = mainGridItems.length > 0 ? Math.max(...mainGridItems.map(item => item.id)) : 0;

        variantSelectedItems.forEach((item) => {
            item.id = lastID + 1;
            lastID += 1;
        });

        const filteredData = [...mainGridItems, ...variantSelectedItems];


        //compare with reference data table and check if the all the items are in filtered data array are in RefDataRow array
        //const RefDataRow = [{ strDET_PROCODE: "1", strDET_PRODESC: "1" ,strDET_STOCKCODE :"1"}, { strDET_PROCODE: "2", strDET_PRODESC: "2",strDET_STOCKCODE :"2" }, { strDET_PROCODE: "3", strDET_PRODESC: "3",strDET_STOCKCODE :"3" }];



        CalculateVariantItemsTax(variantSelectedItems); // Calculate tax for variant items

        if (filteredData.length > 0) {

            //add the new data to the main grid

            filteredData.push({
                dcDET_ACOST: 0,
                dcDET_AMOUNT: 0,
                dcDET_APRICE: 0,
                dcDET_BALQTY: 0,
                dcDET_FBALQTY: 0,
                dcDET_CASEQTY: 0,
                dcDET_CPRICE: 0,
                dcDET_CS: 1,
                dcDET_DISCAMT: 0,
                dcDET_DISCPER: 0,
                dcDET_FCASEQTY: 0,
                dcDET_FUNITQTY: 0,
                dcDET_OAPRICE: 0,
                dcDET_OCPRICE: 0,
                dcDET_OSPRICE: 0,
                dcDET_SPRICE: 0,
                dcDET_SYSQTY: 0,
                dcDET_UNITQTY: 0,
                dcDET_VARQTY: 0,
                dtDET_EXPCHECK: 0,
                dtDET_EXPDAET: "1900-01-01",
                strDET_COMCODE: "",
                strDET_EXPBATCH: "",
                strDET_LOCCODE: "",
                strDET_PROCODE: "",
                strDET_PROCOLOR: "",
                strDET_PRODESC: "",
                strDET_PROSIZE: "",
                strDET_REMCODE: "",
                strDET_RUNNO: "",
                strDET_SACODE: "",
                strDET_STOCKCODE: "",
                strDET_TYPE: "",
                strDET_UNIT: "",
                variant_ENABLE: false,
                disable: false,
                dcDET_SPRICE_OLD: 0,
                dcDET_CPRICE_OLD: 0,
                isDecimal: 0,
                id: lastID + 1,
                openItem: 0,
                innerCS: [{
                    "value": 1,
                    "label": "1",
                }],
                defaultCS: 1,
                fixGP:0
            })

            SetDataRow(filteredData);
        } else {
            SetDataRow(transOBJ);
        }

        toggle();
    };


    const changeObjectValue = (value, id, element) => {

        const objectIndex = VDataRow.findIndex(obj => obj.id == id);
        const newObject = { ...VDataRow[objectIndex], [element]: value };

        SetVDataRow(prevDataRow => {
            const newDataRow = [...prevDataRow];
            newDataRow[objectIndex] = newObject;
            return newDataRow;
        });
    };



    async function handleObjectChange(row, id) {

        const objectIndex = VDataRow.findIndex(obj => obj.id === id);
        const newDataRow = [...VDataRow];
        newDataRow[objectIndex] = row;
        SetVDataRow(newDataRow);

    }


    const handlePageClick = (event) => {
        setPage(event.selected + 1);
    };

    const indexOfLastPost = page * 10
    const indexOfFirstPost = indexOfLastPost - 10
    const currentDetailRows = VDataRow.slice(indexOfFirstPost, indexOfLastPost)


    useEffect(() => {
        SetAlertMsg('')
        SetAlertColor('')
        setShow(false)
    }, [isOpen])

    return (
        <div>
            <Modal
                size="xl"
                isOpen={isOpen}
                toggle={toggle}
                style={{ maxWidth: '90%', width: '90%' }}
                centered={true}
                backdrop="static"
            /*className="modal-fullscreen"*/
            >
                <div className="modal-header">
                    <h5
                        className="modal-title mt-0"
                        id="myExtraLargeModalLabel"
                    >
                        {"Color and Size Details"}
                    </h5>
                    <button
                        onClick={toggle}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div>
                    <Alert color={AlertColor} role="alert" isOpen={show} >
                        {AlertMsg}
                    </Alert>
                </div>
                <div className="modal-body">
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4">{SubTitle} </CardTitle>
                                    <p className="card-title-desc">
                                        {Details}
                                    </p>
                                    <React.Fragment>
                                        <Row>
                                            <i>* press CTRL+ Enter to apply entered quantity to all</i>
                                        </Row>
                                        <Row>
                                            <Col sm={12} md={12} className="mb-12-sm">
                                                <div style={{ overflow: "auto", maxHeight: '500px' }}>
                                                    <table style={{ fontSize: "11px", width: prefixwidth }} id={"TransactionDetV"}>
                                                        {/*className="table-light"*/}
                                                        <thead style={{ position: 'sticky', top: '0', zIndex: '50', backgroundColor: '#FFFFFF' }}>
                                                            <tr>
                                                                <th style={{ width: '20px' }}>#</th>
                                                                <th style={{ textAlign: "left", width: procode.width }}>Code</th>
                                                                {/*txn.TX_STOCKCODE*/ 1 == 1 ? (<th style={{ textAlign: "left", width: stkcode.width }}>Stock Code </th>) : null}
                                                                <th style={{ textAlign: "left", width: prodesc.width }}>Description </th>
                                                                <th style={{ textAlign: "left", width: '80px' }}>Color </th>
                                                                <th style={{ textAlign: "left", width: '80px' }}>Size </th>
                                                                <th style={{ textAlign: "center", width: prounit.width, WebkitTransform: 'rotate(315deg)' }} title="Unit of Measure">Unit</th>
                                                                {txn.intTX_SHOWCS != 0 ? (<th style={{ textAlign: "center", width: procs.width, WebkitTransform: 'rotate(315deg)', height: '65px' }} title="Pack/Case Size">Case/Pack Size</th>) : null}
                                                                {txn.intTX_SHOWSIH != 0 ? (<th style={{ textAlign: "center", width: procs.width, WebkitTransform: 'rotate(315deg)' }} title="Stock in hand">SIH</th>) : null}
                                                                {txn.intTX_EXPCHKSIH == 1 ? (<th style={{ textAlign: "center", width: procs.width, WebkitTransform: 'rotate(315deg)' }}>Expiry Date</th>) : null}
                                                                {/* {txn.strTX_SHOWPRICE == 'C' ? LabelFilter(txn.strTX_SHOWPRICE) : LabelFilter(txn.strTX_PRICEMODE)}
                                                                {txn.strTX_SHOWPRICE == 'C' ? LabelFilter(txn.strTX_PRICEMODE) : LabelFilter(txn.strTX_SHOWPRICE)} */}
                                                                {String(txn.strTX_SHOWPRICE).toLowerCase() == 'c' ? LabelFilter(txn.strTX_SHOWPRICE) : String(txn.strTX_PRICEMODE).toLowerCase() == 'c' ? LabelFilter(txn.strTX_PRICEMODE) : null}
                                                                {String(txn.strTX_SHOWPRICE).toLowerCase() == 's' ? LabelFilter(txn.strTX_SHOWPRICE) : String(txn.strTX_PRICEMODE).toLowerCase() == 's' ? LabelFilter(txn.strTX_PRICEMODE) : null}
                                                                {String(txn.strTX_SHOWPRICE).toLowerCase() == 'a' ? LabelFilter(txn.strTX_SHOWPRICE) : String(txn.strTX_PRICEMODE).toLowerCase() == 'a' ? LabelFilter(txn.strTX_PRICEMODE) : null}
                                                                {String(txn.strTX_SHOWPRICE).toLowerCase() == 'p' ? LabelFilter(txn.strTX_SHOWPRICE) : String(txn.strTX_PRICEMODE).toLowerCase() == 'p' ? LabelFilter(txn.strTX_PRICEMODE) : null}
                                                                {txn.intTX_SHOW_BALQTY == 1 ? (<th style={{ textAlign: "center", WebkitTransform: 'rotate(315deg)' }} title="Balance Quantity">Bal. Qty</th>) : null}
                                                                {txn.intTX_SHOW_FBALQTY == 1 ? (<th style={{ textAlign: "center", WebkitTransform: 'rotate(315deg)' }} title="Balance Quantity">Free Bal. Qty</th>) : null}
                                                                {txn.intTX_CASEQTY != 0 ? (<th style={{ textAlign: "center", width: procaseqty.width, WebkitTransform: 'rotate(315deg)' }} title="Pack/Case Quantity">Case&nbsp;Qty</th>) : null}
                                                                {txn.intTX_UNITQTY != 0 ? (<th style={{ textAlign: "center", width: prouniteqty.width, WebkitTransform: 'rotate(315deg)' }} title={txn.strTX_UNITQTY_CAPTION != "" ? txn.strTX_UNITQTY_CAPTION : 'Unit Quantity'}>{txn.strTX_UNITQTY_CAPTION != "" ? txn.strTX_UNITQTY_CAPTION : 'Unit Qty'}</th>) : null}
                                                                {txn.intTX_FREEUNITQTY != 0 ? (<th style={{ textAlign: "center", width: profreeunit.width, WebkitTransform: 'rotate(315deg)' }} title={txn.strTX_FREEUNITQTY_CAPTION != "" ? txn.strTX_FREEUNITQTY_CAPTION : "Free Unit Quantity"}>{txn.strTX_FREEUNITQTY_CAPTION != "" ? txn.strTX_FREEUNITQTY_CAPTION : "Free\xa0Unit"}</th>) : null}
                                                                {txn.intTX_FREECASEQTY != 0 ? (<th style={{ textAlign: "center", width: profreeunit.width, WebkitTransform: 'rotate(315deg)' }} title="Free Pack/Case Quantity">Free&nbsp;Case</th>) : null}
                                                                {txn.intTX_LINEDISCPER != 0 ? (<th style={{ textAlign: "center", width: prodiscper.width, WebkitTransform: 'rotate(315deg)' }} title="Discount Percentage">Disc % </th>) : null}
                                                                {txn.intTX_LINEDISCAMT != 0 ? (<th style={{ textAlign: "center", width: prodiscamt.width, WebkitTransform: 'rotate(315deg)' }} title="Discount Amount">Disc.&nbsp;Amt.</th>) : null}
                                                                {txn.intTX_HIDEPRICES == 0 ? (<th style={{ textAlign: "center", width: proamt.width, WebkitTransform: 'rotate(315deg)' }}>Amount</th>) : null}
                                                                {txn.intTX_LINEREMARKS != 0 ? (<th style={{ textAlign: "center", width: proremark.width, WebkitTransform: 'rotate(315deg)' }} title="Pre Define Remarks">Remark</th>) : null}
                                                                <th></th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody style={{ fontSize: "10px" }}>
                                                            {(currentDetailRows).map((formRow, key) => (
                                                                <TableRow
                                                                    FormRow={formRow}
                                                                    Key={key}
                                                                    RemoveRow={RemoveRow}
                                                                    Disabled={blDiasableGrid}
                                                                    BookChange={BookChange}
                                                                    SupplierCode={SupplierCode}
                                                                    txnUI={txnUI}
                                                                    procode={procode}
                                                                    stkcode={stkcode}
                                                                    prodesc={prodesc}
                                                                    prounit={prounit}
                                                                    proexpdate={proexpdate}
                                                                    procost={procost}
                                                                    prosell={prosell}
                                                                    proweightavg={proweightavg}
                                                                    prossell={prossell}
                                                                    propackprice={propackprice}
                                                                    probalqty={probalqty}
                                                                    procs={procs}
                                                                    prosih={prosih}
                                                                    procaseqty={procaseqty}
                                                                    prouniteqty={prouniteqty}
                                                                    profreeunit={profreeunit}
                                                                    profreecase={profreecase}
                                                                    prodiscper={prodiscper}
                                                                    prodiscamt={prodiscamt}
                                                                    proamt={proamt}
                                                                    proremark={proremark}
                                                                    txn={txn}
                                                                    taxTable={taxTable}
                                                                    SetTaxTable={SetTaxtTable}
                                                                    SetGrossTotals={SetGrossTotaltx}
                                                                    SetTxNetAmount={SetTxNetAmount}
                                                                    GrossTotal={GrossTotal}
                                                                    SetLineDisc={SetLineDisc}
                                                                    lineDisc={lineDisc}
                                                                    TaxDetails={TaxDetails}
                                                                    RefDataRow={RefDataRow}
                                                                    supplierSelect={supplierSelect}
                                                                    loccode={loccode}
                                                                    DisableDet={DisableDet}
                                                                    AutoScan={autoScan}
                                                                    AddRow={AddRow}
                                                                    setChangeTax={setChangeTax}
                                                                    TxnTotalCal={TxnTotalCal}
                                                                    reasonTypes={reasonTypes}
                                                                    menuCode={menuCode}
                                                                    setDataForRecovery={setDataForRecovery}
                                                                    RemoveRemDetRow={RemoveRemDetRow}
                                                                    menuName={menuName}
                                                                    Reason={Reason}
                                                                    setReason={setReason}
                                                                    setPermissionAlertShow={setPermissionAlertShow}
                                                                    setAlertConfirmOption={setAlertConfirmOption}
                                                                    AlertConfirmOption={AlertConfirmOption}
                                                                    changeObjectValue={changeObjectValue}
                                                                    handleObjectChange={handleObjectChange}
                                                                    VDataRow={VDataRow}
                                                                    SetVDataRow={SetVDataRow}
                                                                    indexOfFirstPost={indexOfFirstPost}
                                                                    priceModeSelect={priceModeSelect}
                                                                    ToLocation={ToLocation}
                                                                />
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <ReactPaginate
                                                previousLabel={'Previous'}
                                                nextLabel={'Next'}
                                                breakLabel={'...'}
                                                pageClassName="page-item"
                                                pageLinkClassName="page-link"
                                                previousClassName="page-item"
                                                previousLinkClassName="page-link"
                                                nextClassName="page-item"
                                                nextLinkClassName="page-link"
                                                breakClassName="page-item"
                                                breakLinkClassName="page-link"
                                                pageCount={Math.ceil(VDataRow.length / 10)}
                                                pageRangeDisplayed={2}
                                                onPageChange={handlePageClick}
                                                forcePage={page - 1}
                                                renderOnZeroPageCount={null}
                                                activeClassName={'active'}
                                                activeLinkClassName={'page-link'}
                                                containerClassName={'pagination justify-content-end pagination-sm'}

                                            />
                                        </Row>
                                    </React.Fragment>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
                <ModalFooter>
                    <Button color="primary" onClick={() => {

                        setTimeout(() => {
                            TxnDet()
                        }, 1000);

                    }}>Apply</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default TransactionVDet;

//* Single Row for TXN Details table */
const TableRow = ({
    FormRow,
    Key,
    procode,
    stkcode,
    prodesc,
    prounit,
    proexpdate,
    procost,
    prosell,
    proweightavg,
    propackprice,
    probalqty,
    procs,
    prosih,
    procaseqty,
    prouniteqty,
    profreeunit,
    profreecase,
    prodiscper,
    prodiscamt,
    proamt,
    proremark,
    txn,
    taxTable,
    SetTaxTable,
    GrossTotal,
    SetGrossTotals,
    SetTxNetAmount,
    SetLineDisc,
    TaxDetails,
    RefDataRow,
    supplierSelect,
    loccode,
    DisableDet,
    AutoScan,
    AddRow,
    setChangeTax,
    TxnTotalCal,
    reasonTypes,
    menuCode,
    setPermissionAlertShow,
    setAlertConfirmOption,
    AlertConfirmOption,
    changeObjectValue,
    handleObjectChange,
    VDataRow,
    SetVDataRow,
    indexOfFirstPost,
    priceModeSelect,
    ToLocation
}) => {


    const {
        isHeadOffice, menus, getMenuDetails, endOfDate, txnDecimalAmt, txnDecimalQty
    } = useContext(Context);

    const [costDisable, setCostDisable] = useState(DisableDet)

    const [sellDisable, setSellDisable] = useState(DisableDet)

    const [ppDisable, setPPDisable] = useState(DisableDet)

    const [showVar, setShowVar] = useState('0.00')
    const [weightavgDisable, SetWeightAvgDisable] = useState(DisableDet)

    const [csQtyDisable, SetcsQtyDisable] = useState(DisableDet)


    const [unitQtyDisable, SetunitQtyDisable] = useState(DisableDet)

    const [funitQtyDisable, SetfunitQtyDisable] = useState(DisableDet)
    const [fcaseQtyDisable, SetfcaseQtyDisable] = useState(DisableDet)
    const [discperDisable, SetdiscperDisable] = useState(DisableDet)


    const [remcodeDisable, SetremcodeDisable] = useState(DisableDet)
    const [isOpen, setIsOpen] = useState(false)

    // const ApiURL = window.Links.ApiURL

    useEffect(() => {

        SetcsQtyDisable(DisableDet)
        SetunitQtyDisable(DisableDet)
        SetfunitQtyDisable(DisableDet)
        SetfcaseQtyDisable(DisableDet)
        SetdiscperDisable(DisableDet)
    }, [DisableDet])

    useEffect(() => {
        //debugger;
        if (TaxDetails != undefined) {
            if (TaxDetails.length == 0) {
                //SetTaxTable([])
            } else {
                const taxTableDat = [...taxTable]
                TaxDetails.map(dr => {
                    taxTableDat.push({ proCode: dr.strTDET_PROCODE, proDesc: FormRow.strDET_PRODESC, taxRate: dr.dcTDET_TAXRATE, taxInclusive: (!dr.blTDET_TAXINC), grossAmt: FormRow.dcDET_AMOUNT, taxtCode: dr.strTDET_TAXCODE, taxDesc: dr.strTDET_TAXCODE, taxtDispRate: dr.dcTDET_TAXRATE })
                })
                SetTaxTable(taxTableDat)
            }
        }
    }, [TaxDetails])



    const [sweetAlertShow, setsweetAlertShow] = useState(false)
    const [AlertDescription, setAlertDescription] = useState(false)

    //**Set the Default sort column and Sort order*/

    const CheckBalQty = async (colType) => {

        return true;

    }

    useEffect(() => {
        TxnTotalCal()
    }, [FormRow.dcDET_AMOUNT])


    //* Calculation */
    const LineAmtCalcualtion = (dcDET_UNITQTY, dcDET_CASEQTY, dcDET_DISCPER, dcDET_DISCAMT, calType = 0, dcDET_FUNITQTY = FormRow.dcDET_FUNITQTY) => {


        if (dcDET_DISCAMT.toString().includes('*')) {
            let disc = dcDET_DISCAMT.substring(dcDET_DISCAMT.indexOf('*') + 1, dcDET_DISCAMT.length)
            disc = parseFloat(disc) * ((parseFloat(FormRow.dcDET_CS) * parseFloat(dcDET_CASEQTY)) + parseFloat(dcDET_UNITQTY));
            changeObjectValue(disc, FormRow.id, "dcDET_DISCAMT")
        }


        if (txn.intTX_SHOWVAR == 1) {
            let SysVar = 0.00
            let enterQty = ((dcDET_CASEQTY == '' ? 0 : parseFloat(dcDET_CASEQTY)) * parseFloat(FormRow.dcDET_CS)) + (dcDET_UNITQTY == '' ? 0 : parseFloat(dcDET_UNITQTY))
            if (txn.intTX_REFQTYCHK == 1) {
                SysVar = parseFloat(FormRow.dcDET_BALQTY) - enterQty;
            } else if (txn.intTX_CHKSIH == 1) {
                SysVar = parseFloat(FormRow.dcDET_SYSQTY) - enterQty;
            }
            setShowVar(SysVar)
        }


        let priceMode = 0
        if (txn.strTX_PRICEMODE == 'C' || txn.strTX_PRICEMODE == 'c') {
            priceMode = parseFloat(FormRow.dcDET_CPRICE.toString().replace(',', ''));
        } else if (txn.strTX_PRICEMODE == 'S' || txn.strTX_PRICEMODE == 's') {
            priceMode = parseFloat(FormRow.dcDET_SPRICE.toString().replace(',', ''));//sell;
        } else if (txn.strTX_PRICEMODE == 'A' || txn.strTX_PRICEMODE == 'a') {
            priceMode = parseFloat(FormRow.dcDET_ACOST);
        } else if (txn.strTX_PRICEMODE == 'P' || txn.strTX_PRICEMODE == 'p') {
            priceMode = parseFloat(FormRow.dbPackPrice) / parseFloat(FormRow.dcDET_CS);
        }

        const cseQty = parseFloat(FormRow.dcDET_CASEQTY == "" ? 0 : parseFloat(FormRow.dcDET_CASEQTY))
        const totalCaseQty = String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "c" ? cseQty : cseQty * parseFloat(FormRow.dcDET_CS)
        const unitQty = parseFloat(FormRow.dcDET_UNITQTY == "" ? 0 : parseFloat(FormRow.dcDET_UNITQTY))
        const totalUnitQty = String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "c" ? unitQty / parseFloat(FormRow.dcDET_CS) : unitQty
        const totalFreeUnit = String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "c" || String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "a" ? parseFloat(dcDET_FUNITQTY) / parseFloat(FormRow.dcDET_CS) : parseFloat(dcDET_FUNITQTY)
        const freeCaseQty = String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "c" || String(txn.strTX_PRICEMODE).toLocaleLowerCase() == "a" ? parseFloat(FormRow.dcDET_FCASEQTY) / parseFloat(FormRow.dcDET_CS) : parseFloat(FormRow.dcDET_FCASEQTY)

        let grossAmount = 0

        if (txn.intTX_BOM == 1) {

            grossAmount = parseFloat(priceMode) * (freeCaseQty)

        } else if (txn.intTX_PRODUCTION == 1 || txn.intTX_VERIFICATION == 1) {
            if (txn.intTX_VERIFICATION == 1) {
                grossAmount = parseFloat(priceMode) * (totalCaseQty + parseFloat(totalUnitQty + parseFloat(totalFreeUnit)))
            } else {
                grossAmount = parseFloat(priceMode) * (totalCaseQty + parseFloat(totalUnitQty - parseFloat(totalFreeUnit)))
            }
        } else {
            grossAmount = parseFloat(priceMode) * (totalCaseQty + totalUnitQty)
        }

        let NetAmount = grossAmount - (((parseFloat(dcDET_DISCPER) * grossAmount) / 100) + parseFloat(dcDET_DISCAMT));
        let grossHedAmt = GrossTotal.toString();
        grossHedAmt = grossHedAmt && grossHedAmt.includes(',') ? GrossTotal.replace(',', '') : GrossTotal;
        let mainGrossTotal = parseFloat(grossHedAmt) > 0 ? parseFloat(grossHedAmt) - parseFloat(FormRow.dcDET_AMOUNT) : 0.00;

        if (calType == 0) {
            SetGrossTotals(parseFloat(mainGrossTotal) + parseFloat(NetAmount));
            SetTxNetAmount(parseFloat(mainGrossTotal) + parseFloat(NetAmount));
            setTimeout(() => { SetLineDisc(getLineDicTotal) }, 1);
            const taxTableDat = []
            SetTaxTable(taxTableDat)
            setChangeTax(taxTableDat)
        } else {
            SetGrossTotals(parseFloat(mainGrossTotal) - parseFloat(NetAmount));
            SetTxNetAmount(parseFloat(mainGrossTotal) - parseFloat(NetAmount));
            setTimeout(() => { SetLineDisc(getLineDicTotal) }, 1);
            const taxTableDat = []
            SetTaxTable(taxTableDat)
            setChangeTax(taxTableDat)
        }


        let currentRow = FormRow;

        if (currentRow.isDecimal == 1) {
            currentRow.dcDET_UNITQTY = parseFloat(dcDET_UNITQTY).toFixed(txnDecimalQty);
            currentRow.dcDET_CASEQTY = parseFloat(dcDET_CASEQTY).toFixed(0);
            currentRow.dcDET_FUNITQTY = parseFloat(dcDET_FUNITQTY).toFixed(txnDecimalQty);
        } else {
            currentRow.dcDET_UNITQTY = parseInt(dcDET_UNITQTY).toFixed(0);
            currentRow.dcDET_CASEQTY = parseInt(dcDET_CASEQTY).toFixed(0);
            currentRow.dcDET_FUNITQTY = parseInt(dcDET_FUNITQTY).toFixed(0);
        }

        currentRow.dcDET_DISCPER = parseFloat(dcDET_DISCPER).toFixed(txnDecimalQty);
        currentRow.dcDET_DISCAMT = parseFloat(dcDET_DISCAMT).toFixed(txnDecimalAmt);
        currentRow.dcDET_AMOUNT = parseFloat(NetAmount).toFixed(txnDecimalAmt);

        handleObjectChange(currentRow, currentRow.id);

        TxnTotalCal()

    }



    /*
        1.This function is used to apply unit or case qty to all rows
        2. It will take two parameters
            a. mainQty = main qty which is selected by user
            b. type = type of qty which is selected by user
        3. It will loop through all rows and apply mainQty to all rows
        4. It will also calculate amount.
    */
    const ApplyToAll = (mainQty, type) => {

        var VariantTable = [...VDataRow]

        VDataRow.map((item, index) => {

            let priceMode = 0
            if (txn.strTX_PRICEMODE == 'C' || txn.strTX_PRICEMODE == 'c') {
                priceMode = parseFloat(item.dcDET_CPRICE.toString().replace(',', ''));
            } else if (txn.strTX_PRICEMODE == 'S' || txn.strTX_PRICEMODE == 's') {
                priceMode = parseFloat(item.dcDET_SPRICE.toString().replace(',', ''));//sell;
            } else if (txn.strTX_PRICEMODE == 'A' || txn.strTX_PRICEMODE == 'a') {
                priceMode = parseFloat(item.dcDET_ACOST);
            } else if (txn.strTX_PRICEMODE == 'P' || txn.strTX_PRICEMODE == 'p') {
                priceMode = parseFloat(item.dbPackPrice) / parseFloat(item.dcDET_CS);
            }

            let freeUnitQty = item.dcDET_FUNITQTY
            if (txn.intTX_FREEQTYMINUS == 1 && txn.intTX_BOM == 0) {
                freeUnitQty = Math.abs(dcDET_FUNITQTY) * -1;
            }

            let grossAmount = parseFloat(priceMode) * ((parseFloat(type == 'CASE' ? parseFloat(mainQty) : parseFloat(item.dcDET_CASEQTY)) * parseFloat(item.dcDET_CS)) + parseFloat(type == 'UNIT' ? parseFloat(mainQty) : parseFloat(item.dcDET_UNITQTY)) + parseFloat(freeUnitQty));
            let NetAmount = grossAmount - (((parseFloat(item.dcDET_DISCPER) * grossAmount) / 100) + parseFloat(item.dcDET_DISCAMT));
            let grossHedAmt = GrossTotal.toString();
            grossHedAmt = grossHedAmt && grossHedAmt.includes(',') ? GrossTotal.replace(',', '') : GrossTotal;

            const qtyKey = type == 'UNIT' ? 'dcDET_UNITQTY' : 'dcDET_CASEQTY';

            if (VariantTable[index].isDecimal == 1) {
                VariantTable[index][qtyKey] = parseFloat(mainQty).toFixed(txnDecimalQty);
            } else {
                VariantTable[index][qtyKey] = parseInt(mainQty, 10).toFixed(0);
            }

            VariantTable[index].dcDET_DISCPER = parseFloat(item.dcDET_DISCPER).toFixed(txnDecimalQty)
            VariantTable[index].dcDET_DISCAMT = parseFloat(item.dcDET_DISCAMT).toFixed(txnDecimalAmt)

            VariantTable[index].dcDET_AMOUNT = parseFloat(NetAmount).toFixed(txnDecimalAmt)

        })

        SetVDataRow(VariantTable)
        return true
    }


    const KeyPressEvnt = async (e, Key) => {

        let cost = document.getElementById('V_DET_CPRICE' + Key)
        let sell = document.getElementById('V_DET_SPRICE' + Key)
        let avg = document.getElementById('V_DET_ACOST' + Key)
        let pp = document.getElementById('V_DET_PPRICE' + Key)
        if (e.ctrlKey && e.charCode == 13) {

            if (txn.intTX_SHOWPRICEMODE == 0 && priceModeSelect == "") {
                if (e.target.id == "V_DET_UNITQTY" + Key) {
                    ApplyToAll(e.target.value, "UNIT")
                } else if (e.target.id == "V_DET_CASEQTY" + Key) {
                    ApplyToAll(e.target.value, "CASE")
                } else if (e.target.id == "V_DET_FUNITQTY" + Key) {
                    ApplyToAll(e.target.value, "UNIT")
                }
            }

        } else if (e.charCode == 13) {

            if (e.target.id == "V_DET_PRODESC" + Key) {
                if (txn.intTX_EXPCHKSIH == 1) {
                    document.getElementById("V_DET_EXPDATE" + Key).focus();
                    return
                } else if (cost != null && cost.style.visibility == 'visible' && !costDisable && txn.intTX_CHANGEPRICE == 1) {
                    cost.focus()
                    return
                } else if (sell != null && sell.style.visibility == 'visible' && !sellDisable && txn.intTX_CHANGEPRICE == 1) {
                    sell.focus()
                    return
                } else if (avg != null && avg.style.visibility == 'visible' && !weightavgDisable && txn.intTX_CHANGEPRICE == 1) {
                    avg.focus();
                    return
                } else if (pp != null && pp.style.visibility == 'visible' && !ppDisable && txn.intTX_CHANGEPRICE == 1) {
                    pp.focus();
                    return
                } else if (txn.intTX_CASEQTY != 0) {
                    document.getElementById("V_DET_CASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_UNITQTY != 0) {
                    document.getElementById("V_DET_UNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREEUNITQTY != 0) {
                    document.getElementById("V_DET_FUNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREECASEQTY != 0) {
                    document.getElementById("V_DET_FCASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_DISCPER" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCAMT != 0) {
                    document.getElementById("V_DET_DISCAMT" + Key).focus();
                    return
                } else if (txn.intTX_LINEREMARKS != 0) {
                    document.getElementById("V_DET_REMCODE" + Key).focus();
                    return
                }

            }
            if (e.target.id == "V_DET_CPRICE" + Key) {
                if (sell != null && sell.style.visibility == 'visible') {
                    sell.focus()
                    return
                } else if (avg != null && avg.style.visibility == 'visible') {
                    avg.focus();
                    return
                } else if (pp != null && pp.style.visibility == 'visible') {
                    pp.focus();
                    return
                } else if (txn.intTX_CASEQTY != 0) {
                    document.getElementById("V_DET_CASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_UNITQTY != 0) {
                    document.getElementById("V_DET_UNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREEUNITQTY != 0) {
                    document.getElementById("V_DET_FUNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREECASEQTY != 0) {
                    document.getElementById("V_DET_FCASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_DISCPER" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCAMT != 0) {
                    document.getElementById("V_DET_DISCAMT" + Key).focus();
                    return
                } else if (txn.intTX_LINEREMARKS != 0) {
                    document.getElementById("V_DET_REMCODE" + Key).focus();
                    return
                }

            }
            if (e.target.id == "V_DET_SPRICE" + Key) {
                if (AlertConfirmOption == 100) {
                    return;
                }
                if (avg != null && avg.style.visibility == 'visible') {
                    avg.focus();
                    return
                } else if (pp != null && pp.style.visibility == 'visible') {
                    pp.focus();
                    return
                } else if (txn.intTX_CASEQTY != 0) {
                    document.getElementById("V_DET_CASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_UNITQTY != 0) {
                    document.getElementById("V_DET_UNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREEUNITQTY != 0) {
                    document.getElementById("V_DET_FUNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREECASEQTY != 0) {
                    document.getElementById("V_DET_FCASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_DISCPER" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCAMT != 0) {
                    document.getElementById("V_DET_DISCAMT" + Key).focus();
                    return
                } else if (txn.intTX_LINEREMARKS != 0) {
                    document.getElementById("V_DET_REMCODE" + Key).focus();
                    return
                }

            }
            if (e.target.id == "V_DET_EXPDATE" + Key) {
                if (cost != null && cost.style.visibility == 'visible' && !costDisable) {
                    cost.focus()
                    return
                } else if (sell != null && sell.style.visibility == 'visible' && !sellDisable) {
                    sell.focus()
                    return
                } else if (avg != null && avg.style.visibility == 'visible' && !weightavgDisable) {
                    avg.focus();
                    return
                } else if (pp != null && pp.style.visibility == 'visible' && !ppDisable) {
                    pp.focus();
                    return
                } else if (txn.intTX_CASEQTY != 0) {
                    document.getElementById("V_DET_CASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_UNITQTY != 0) {
                    document.getElementById("V_DET_UNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREEUNITQTY != 0) {
                    document.getElementById("V_DET_FUNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREECASEQTY != 0) {
                    document.getElementById("V_DET_FCASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_DISCPER" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCAMT != 0) {
                    document.getElementById("V_DET_DISCAMT" + Key).focus();
                    return
                } else if (txn.intTX_LINEREMARKS != 0) {
                    document.getElementById("V_DET_REMCODE" + Key).focus();
                    return
                }

            }
            if (e.target.id == "V_DET_CPRICE" + Key) {
                if (sell != null && sell.style.visibility == 'visible') {
                    sell.focus()
                    return
                } else if (avg != null && avg.style.visibility == 'visible') {
                    avg.focus();
                    return
                } else if (pp != null && pp.style.visibility == 'visible') {
                    pp.focus();
                    return
                } else if (txn.intTX_CASEQTY != 0) {
                    document.getElementById("V_DET_CASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_UNITQTY != 0) {
                    document.getElementById("V_DET_UNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREEUNITQTY != 0) {
                    document.getElementById("V_DET_FUNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREECASEQTY != 0) {
                    document.getElementById("V_DET_FCASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_DISCPER" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCAMT != 0) {
                    document.getElementById("V_DET_DISCAMT" + Key).focus();
                    return
                } else if (txn.intTX_LINEREMARKS != 0) {
                    document.getElementById("V_DET_REMCODE" + Key).focus();
                    return
                }

            }
            if (e.target.id == "V_DET_SPRICE" + Key) {
                if (AlertConfirmOption == 100) {
                    return;
                }
                if (avg != null && avg.style.visibility == 'visible') {
                    avg.focus();
                    return
                } else if (pp != null && pp.style.visibility == 'visible') {
                    pp.focus();
                    return
                } else if (txn.intTX_CASEQTY != 0) {
                    document.getElementById("V_DET_CASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_UNITQTY != 0) {
                    document.getElementById("V_DET_UNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREEUNITQTY != 0) {
                    document.getElementById("V_DET_FUNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREECASEQTY != 0) {
                    document.getElementById("V_DET_FCASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_DISCPER" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCAMT != 0) {
                    document.getElementById("V_DET_DISCAMT" + Key).focus();
                    return
                } else if (txn.intTX_LINEREMARKS != 0) {
                    document.getElementById("V_DET_REMCODE" + Key).focus();
                    return
                }

            }
            if (e.target.id == "V_DET_ACOST" + Key) {
                if (pp != null && pp.style.visibility == 'visible') {
                    pp.focus();
                    return
                } else if (txn.intTX_CASEQTY != 0) {
                    document.getElementById("V_DET_CASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_UNITQTY != 0) {
                    document.getElementById("V_DET_UNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREEUNITQTY != 0) {
                    document.getElementById("V_DET_FUNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREECASEQTY != 0) {
                    document.getElementById("V_DET_FCASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_DISCPER" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCAMT != 0) {
                    document.getElementById("V_DET_DISCAMT" + Key).focus();
                    return
                } else if (txn.intTX_LINEREMARKS != 0) {
                    document.getElementById("V_DET_REMCODE" + Key).focus();
                    return
                }

            }
            if (e.target.id == "V_DET_PPRICE" + Key) {
                if (txn.intTX_CASEQTY != 0) {
                    document.getElementById("V_DET_CASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_UNITQTY != 0) {
                    document.getElementById("V_DET_UNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREEUNITQTY != 0) {
                    document.getElementById("V_DET_FUNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREECASEQTY != 0) {
                    document.getElementById("V_DET_FCASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_DISCPER" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCAMT != 0) {
                    document.getElementById("V_DET_DISCAMT" + Key).focus();
                    return
                } else if (txn.intTX_LINEREMARKS != 0) {
                    document.getElementById("V_DET_REMCODE" + Key).focus();
                    return
                }

            }
            if (e.target.id == "V_DET_CASEQTY" + Key) {
                if (AlertConfirmOption == 100) {
                    sell.focus();
                    return;
                }
                if (txn.intTX_UNITQTY != 0) {
                    document.getElementById("V_DET_UNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREEUNITQTY != 0) {
                    document.getElementById("V_DET_FUNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREECASEQTY != 0) {
                    document.getElementById("V_DET_FCASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_DISCPER" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCAMT != 0) {
                    document.getElementById("V_DET_DISCAMT" + Key).focus();
                    return
                } else if (txn.intTX_LINEREMARKS != 0) {
                    document.getElementById("V_DET_REMCODE" + Key).focus();
                    return
                }

            }
            if (e.target.id == "V_DET_UNITQTY" + Key) {
                //debugger;
                if (AlertConfirmOption == 100) {
                    sell.focus();
                    return;
                }

                //* Only for SVM transaction */
                if (txn.strTX_TYPE == 'SVM') {
                    if (parseFloat(FormRow.dcDET_FUNITQTY) > 0) {
                        // setfunitQty('0')
                        changeObjectValue(0, FormRow.id, "dcDET_FUNITQTY")
                    }

                    if (parseFloat(FormRow.dcDET_UNITQTY) == 0) {
                        document.getElementById("V_DET_FUNITQTY" + Key).focus();
                        return
                    }
                }

                //* End SVM transaction Validation*/

                if (txn.intTX_FREEUNITQTY != 0) {
                    document.getElementById("V_DET_FUNITQTY" + Key).focus();
                    return
                } else if (txn.intTX_FREECASEQTY != 0) {
                    document.getElementById("V_DET_FCASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_DISCPER" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCAMT != 0) {
                    document.getElementById("V_DET_DISCAMT" + Key).focus();
                    return
                } else if (txn.intTX_LINEREMARKS != 0) {
                    document.getElementById("V_DET_REMCODE" + Key).focus();
                    return
                }

            }
            if (e.target.id == "V_DET_FUNITQTY" + Key) {
                if (AlertConfirmOption == 100) {
                    sell.focus();
                    return;
                }

                //* End SVM transaction Validation*/
                if (txn.intTX_FREECASEQTY != 0) {
                    document.getElementById("V_DET_FCASEQTY" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_DISCPER" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCAMT != 0) {
                    document.getElementById("V_DET_DISCAMT" + Key).focus();
                    return
                } else if (txn.intTX_LINEREMARKS != 0) {
                    document.getElementById("V_DET_REMCODE" + Key).focus();
                    return
                }

            }
            if (e.target.id == "V_DET_FCASEQTY" + Key) {
                if (AlertConfirmOption == 100) {
                    sell.focus();
                    return;
                }
                if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_DISCPER" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_DISCAMT" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_REMCODE" + Key).focus();
                    return
                }

            }
            if (e.target.id == "V_DET_DISCPER" + Key) {
                if (AlertConfirmOption == 100) {
                    sell.focus();
                    return;
                }
                if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_DISCAMT" + Key).focus();
                    return
                } else if (txn.intTX_LINEDISCPER != 0) {
                    document.getElementById("V_DET_REMCODE" + Key).focus();
                    return
                }

            }
            if (e.target.id == "V_DET_DISCAMT" + Key) {
                //debugger;
                if (AlertConfirmOption == 100) {
                    sell.focus();
                    return;
                }
                if (parseFloat(FormRow.dcDET_DISCAMT) > parseFloat(FormRow.dcDET_AMOUNT)) {
                    // setdiscAmt('0.00')
                    changeObjectValue(parseFloat(0), FormRow.id, "dcDET_DISCAMT")
                }
                if (FormRow.dcDET_DISCAMT.toString().includes('*')) {
                    let disc = FormRow.dcDET_DISCAMT.substring(FormRow.dcDET_DISCAMT.indexOf('*') + 1, FormRow.dcDET_DISCAMT.length)
                    disc = parseFloat(disc) * ((parseFloat(FormRow.dcDET_CS) * parseFloat(FormRow.dcDET_CASEQTY)) + parseFloat(FormRow.dcDET_UNITQTY));
                    // setdiscAmt(disc)
                    changeObjectValue(parseFloat(disc), FormRow.id, "dcDET_DISCAMT")
                }
                if (txn.intTX_LINEREMARKS != 0) {
                    setTimeout(() => {
                        document.getElementById("V_DET_REMCODE" + Key).focus();
                    }, 1)
                    return
                }

            }
            if (e.target.id == "V_DET_REMCODE" + Key) {
                if (AlertConfirmOption == 100) {
                    sell.focus();
                    return;
                }

                return
            }
        }
    }
    //* End Enter Key press */



    return (
        <tr key={FormRow.id}>
            <td>
                <Row className="mb-0">
                    <Col md="12" id={"txtID" + Key}>{indexOfFirstPost + Key + 1}</Col>
                </Row>
            </td>
            <td style={{ width: parseInt(procode.width) }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="text"
                            maxLength={procode.len}
                            id={'V_' + procode.name + Key}
                            value={FormRow.strDET_PROCODE}
                            disabled={true}
                            onChange={e => {
                                let txt = Text(e.target, 25, true, true, 'upper', false)
                                changeObjectValue(txt, FormRow.id, "strDET_PROCODE")
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >
            {/*txn.TX_STOCKCODE*/ 1 == 1 ? (<td style={{ width: parseInt(stkcode.width) }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="text"
                            maxLength={stkcode.len}
                            id={'V_' + stkcode.name + Key}
                            value={FormRow.strDET_STOCKCODE}
                            disabled={true}
                            onChange={e => {
                                let txt = Text(e.target, 25, true, false, 'upper', false)
                                changeObjectValue(txt, FormRow.id, "strDET_STOCKCODE")
                            }}
                            onKeyPress={e => {
                                KeyPressEvnt(e, Key)
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >) : null}
            <td style={{ width: parseInt(prodesc.width) }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="text"
                            maxLength={prodesc.len}
                            id={'V_' + prodesc.name + Key}
                            value={FormRow.strDET_PRODESC}
                            disabled={true}
                            onChange={e => {
                                let txt = Text(e.target, 50, true, true, 'upper', true)
                                changeObjectValue(txt, FormRow.id, "strDET_PRODESC")
                            }}
                            onKeyPress={e => {
                                KeyPressEvnt(e, Key)
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >
            <td >
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="text"
                            maxLength={prodesc.len}
                            id={"colors" + Key}
                            value={FormRow.strDET_PROCOLOR}
                            disabled={true}
                            onChange={e => {
                                let txt = Text(e.target, 50, true, true, 'upper', true)
                                changeObjectValue(txt, FormRow.id, "strDET_PROCOLOR")
                            }}
                            onKeyPress={e => {
                                KeyPressEvnt(e, Key)
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >
            <td >
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="text"
                            maxLength={prodesc.len}
                            id={"size" + Key}
                            value={FormRow.strDET_PROSIZE}
                            disabled={true}
                            onChange={e => {
                                let txt = Text(e.target, 50, true, true, 'upper', true)
                                changeObjectValue(txt, FormRow.id, "strDET_PROSIZE")
                            }}
                            onKeyPress={e => {
                                KeyPressEvnt(e, Key)
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >
            <td style={{ width: parseInt(prounit.width) }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="text"
                            maxLength={prounit.len}
                            id={'V_' + prounit.name + Key}
                            value={FormRow.strDET_UNIT}
                            disabled={true}
                            onChange={e => {
                                let txt = Numeric(e.target, 18, txnDecimalQty, false)
                                changeObjectValue(txt, FormRow.id, "strDET_UNIT")
                            }}

                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >
            {txn.intTX_SHOWCS != 0 ? (<td style={{ width: parseInt(procs.width) }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="text"
                            textAlign={'right'}
                            maxLength={procs.len}
                            id={'V_' + procs.name + Key}
                            value={parseFloat(FormRow.dcDET_CS)}
                            disabled={true}
                            onChange={e => {
                                let txt = Numeric(e.target, 18, txnDecimalQty, false)
                                changeObjectValue(txt, FormRow.id, "dcDET_CS")
                            }}
                            onKeyPress={e => {
                                KeyPressEvnt(e, Key)
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >) : null}
            {txn.intTX_SHOWSIH != 0 ? (<td style={{ width: parseInt(prosih.width) }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="text"
                            textAlign={'right'}
                            maxLength={prosih.len}
                            id={'V_' + prosih.name + Key}
                            value={parseFloat(FormRow.dcDET_SYSQTY)}
                            disabled={true}
                            onChange={e => {
                                let txt = Numeric(e.target, 18, txnDecimalQty, false)
                                changeObjectValue(txt, FormRow.id, "dcDET_SYSQTY")
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >) : null}
            {txn.intTX_SHOWVAR == 1 ? (<td style={{ width: parseInt(prosih.width) }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="text"
                            textAlign={'right'}
                            maxLength={prosih.len}
                            id={'V_' + prosih.name + 'var' + Key}
                            value={showVar}
                            disabled={true}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >) : null}
            {txn.intTX_EXPCHKSIH == 1 ? (<td style={{ maxWidth: parseInt(proexpdate.width) }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="date"
                            maxLength={proexpdate.len}
                            id={'V_' + proexpdate.name + Key}
                            value={FormRow.dtDET_EXPDAET}
                            disabled={true}
                            onChange={e => {
                                //setexp(e.target.value)
                                changeObjectValue(e.target.value, FormRow.id, "dtDET_EXPDAET")
                            }}
                            onKeyPress={e => {
                                KeyPressEvnt(e, Key)
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >) : null}
            <td style={{ width: parseInt(procost.width), visibility: txn.strTX_PRICEMODE == 'C' || txn.strTX_SHOWPRICE == 'C' ? 'visible' : 'hidden', display: txn.strTX_PRICEMODE == 'C' || txn.strTX_SHOWPRICE == 'C' ? 'table-cell' : 'none' }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="text"
                            maxLength={procost.len}
                            id={'V_' + procost.name + Key}
                            value={FormRow.dcDET_CPRICE}
                            visibility={txn.strTX_PRICEMODE == 'C' || txn.strTX_SHOWPRICE == 'C' ? 'visible' : 'hidden'}
                            disabled={txn.intTX_CHANGEPRICE == 0 ? true : costDisable}
                            textAlign={"right"}
                            onChange={e => {
                                let txt = Numeric(e.target, 18, txnDecimalAmt, false)

                                changeObjectValue(txt, FormRow.id, "dcDET_CPRICE")
                            }}
                            onKeyPress={e => {
                                KeyPressEvnt(e, Key)
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >
            <td style={{ width: parseInt(prosell.width), visibility: txn.strTX_PRICEMODE == 'S' || txn.strTX_SHOWPRICE == 'S' ? 'visible' : 'hidden', display: txn.strTX_PRICEMODE == 'S' || txn.strTX_SHOWPRICE == 'S' ? 'table-cell' : 'none' }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="text"
                            maxLength={prosell.len}
                            id={'V_' + prosell.name + Key}
                            value={FormRow.dcDET_SPRICE}
                            visibility={txn.strTX_PRICEMODE == 'S' || txn.strTX_SHOWPRICE == 'S' ? 'visible' : 'hidden'}
                            textAlign={"right"}
                            disabled={txn.intTX_CHANGEPRICE == 0 ? true : sellDisable}
                            onChange={e => {
                                let txt = Numeric(e.target, 18, txnDecimalAmt, false)
                                //setsell(txt)
                                changeObjectValue(txt, FormRow.id, "dcDET_SPRICE")
                            }}
                            onKeyPress={e => {
                                KeyPressEvnt(e, Key)
                            }}
                            onBlur={(e) => {
                                // if (parseFloat(FormRow.dcDET_CPRICE) > parseFloat(FormRow.dcDET_SPRICE)) {
                                //     setAlertConfirmOption(100)
                                //     setPermissionAlertShow(true)
                                // }
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >
            <td style={{ width: parseInt(proweightavg.width), visibility: txn.strTX_PRICEMODE == 'A' || txn.strTX_SHOWPRICE == 'A' ? 'visible' : 'hidden', display: txn.strTX_PRICEMODE == 'A' || txn.strTX_SHOWPRICE == 'A' ? 'block' : 'none' }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="text"
                            maxLength={proweightavg.len}
                            id={'V_' + proweightavg.name + Key}
                            visibility={txn.strTX_PRICEMODE == 'A' || txn.strTX_SHOWPRICE == 'A' ? 'visible' : 'hidden'}
                            value={FormRow.dcDET_ACOST}
                            textAlign={"right"}
                            disabled={weightavgDisable}
                            onChange={e => {
                                let txt = Numeric(e.target, 18, txnDecimalAmt, false)
                                //setWeightavg(txt)
                                changeObjectValue(txt, FormRow.id, "dcDET_ACOST")
                            }}
                            onKeyPress={e => {
                                KeyPressEvnt(e, Key)
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >
            <td style={{ width: parseInt(propackprice.width), visibility: txn.strTX_PRICEMODE == 'P' || txn.strTX_SHOWPRICE == 'P' ? 'visible' : 'hidden', display: txn.strTX_PRICEMODE == 'P' || txn.strTX_SHOWPRICE == 'P' ? 'block' : 'none' }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="text"
                            maxLength={propackprice.len}
                            id={'V_' + propackprice.name + Key}
                            visibility={txn.strTX_PRICEMODE == 'P' || txn.strTX_SHOWPRICE == 'P' ? 'visible' : 'hidden'}
                            value={FormRow.dbPackPrice}
                            textAlign={"right"}
                            disabled={ppDisable}
                            onChange={e => {
                                let txt = Numeric(e.target, 18, txnDecimalAmt, false)
                                //setpp(txt)
                                changeObjectValue(txt, FormRow.id, "dbPackPrice")
                            }}
                            onKeyPress={e => {
                                KeyPressEvnt(e, Key)
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >
            {/*txn.strTX_SHOWPRICE == 'C' ? LabelFilter(txn.strTX_SHOWPRICE, sellDisable) : LabelFilter(txn.strTX_PRICEMODE, costDisable)}
            {txn.strTX_SHOWPRICE == 'C' ? LabelFilter(txn.strTX_PRICEMODE, costDisable) : LabelFilter(txn.strTX_SHOWPRICE, sellDisable)*/}
            {txn.intTX_SHOW_BALQTY == 1 ? (<td style={{ width: parseInt(probalqty.width) }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="text"
                            maxLength={probalqty.len}
                            id={'V_' + probalqty.name + Key}
                            value={FormRow.dcDET_BALQTY}
                            textAlign={'right'}
                            disabled={true}//balqtyDisable}
                            onChange={e => {
                                let txt = 0
                                if (FormRow.isDecimal == 1) {
                                    txt = Numeric(e.target, 18, txnDecimalQty, false)
                                } else {
                                    txt = Numeric(e.target, 18, 0, false)
                                }

                                changeObjectValue(txt, FormRow.id, "dcDET_BALQTY")
                            }}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >) : null}
            {txn.intTX_SHOW_FBALQTY == 1 ? (<td style={{ width: parseInt(probalqty.width) }}>
                <Row className="mb-0">
                    <Col md="12">
                        <DPTextBoxforgrid
                            rowClass="mb-12-sm"
                            labelText=""
                            textType="text"
                            maxLength={probalqty.len}
                            id={'V_' + 'dcDET_FBALQTY' + Key}
                            value={FormRow.dcDET_FBALQTY}
                            textAlign={'right'}
                            disabled={true}//balqtyDisable}
                        ></DPTextBoxforgrid>
                    </Col>
                </Row>
            </td >) : null}
            {txn.intTX_CASEQTY != 0 ? (
                <td style={{ width: parseInt(procaseqty.width) }}>
                    <Row className="mb-0">
                        <Col md="12">
                            <DPTextBoxforgrid
                                rowClass="mb-12-sm"
                                labelText=""
                                textType="text"
                                maxLength={procaseqty.len}
                                id={'V_' + procaseqty.name + Key}
                                value={FormRow.dcDET_CASEQTY}
                                textAlign={'right'}
                                disabled={csQtyDisable}
                                onChange={e => {
                                    let txt = 0
                                    if (FormRow.isDecimal == 1) {
                                        txt = Numeric(e.target, 18, 0, false)
                                    } else {
                                        txt = Numeric(e.target, 18, 0, false)
                                    }

                                    changeObjectValue(txt, FormRow.id, "dcDET_CASEQTY")
                                }}
                                onBlur={async (e) => {
                                    let unti = e.target.value
                                    if (unti.length <= 0) {
                                        changeObjectValue(0, FormRow.id, "dcDET_CASEQTY")
                                        unti = 0
                                    }

                                    const balanceResponse = await CheckBalQty(1)
                                    var newRow = FormRow
                                    if (txn.intTX_SHOWPRICEMODE == 1 && priceModeSelect != "") {
                                        const currQty = parseFloat(FormRow.dcDET_UNITQTY) + (parseFloat(FormRow.dcDET_CS) * parseFloat(unti))

                                        const PROPRICE = await getTxnProductPricemode(FormRow.strDET_PROCODE, loccode, priceModeSelect, currQty)

                                        if (PROPRICE.status == 1) { //if product price is available then set the price
                                            newRow.dcDET_SPRICE = parseFloat(PROPRICE.price) == 0 ? parseFloat(FormRow.dcDET_SPRICE_OLD).toFixed(txnDecimalAmt) : parseFloat(PROPRICE.price).toFixed(txnDecimalAmt)
                                            newRow.dcDET_DISCAMT = parseFloat(PROPRICE.discAmt).toFixed(txnDecimalAmt)
                                            newRow.dcDET_DISCPER = parseFloat(PROPRICE.discPer).toFixed(2)
                                        } else {  //if product price is not available then set the old price
                                            newRow.dcDET_SPRICE = FormRow.dcDET_SPRICE_OLD
                                        }
                                    }
                                    if (balanceResponse) {
                                        LineAmtCalcualtion(FormRow.dcDET_UNITQTY, unti, newRow.dcDET_DISCPER, newRow.dcDET_DISCAMT)
                                    } else {
                                        LineAmtCalcualtion(FormRow.dcDET_UNITQTY, 0, newRow.dcDET_DISCPER, newRow.dcDET_DISCAMT)
                                    }

                                }}
                                onKeyPress={e => {
                                    KeyPressEvnt(e, Key)
                                }}
                            ></DPTextBoxforgrid>
                        </Col>
                    </Row>
                </td >) : null}
            {txn.intTX_UNITQTY == 1 ? (
                <td style={{ width: parseInt(prouniteqty.width) }}>
                    <Row className="mb-0">
                        <Col md="12">
                            <DPTextBoxforgrid
                                rowClass="mb-12-sm"
                                labelText=""
                                textType="text"
                                maxLength={prouniteqty.len}
                                id={'V_' + prouniteqty.name + Key}
                                textAlign={'right'}
                                value={FormRow.dcDET_UNITQTY}
                                disabled={unitQtyDisable}
                                onChange={e => {
                                    let txt = 0
                                    if (FormRow.isDecimal == 1) {
                                        txt = Numeric(e.target, 18, txnDecimalQty, false)
                                    } else {
                                        txt = Numeric(e.target, 18, 0, false)
                                    }


                                    changeObjectValue(txt, FormRow.id, "dcDET_UNITQTY")
                                }}
                                onBlur={async (e) => {
                                    let unti = e.target.value
                                    if (unti.length <= 0) {
                                        await changeObjectValue(0, FormRow.id, "dcDET_UNITQTY")
                                        unti = 0
                                    }

                                    const balanceResponse = await CheckBalQty(2)
                                    var newRow = FormRow

                                    if (txn.intTX_SHOWPRICEMODE == 1 && priceModeSelect != "") {
                                        const currQty = parseFloat(unti) + (parseFloat(FormRow.dcDET_CS) * parseFloat(FormRow.dcDET_CASEQTY))

                                        const PROPRICE = await getTxnProductPricemode(FormRow.strDET_PROCODE, loccode, priceModeSelect, currQty)

                                        if (PROPRICE.status == 1) { //if product price is available then set the price
                                            newRow.dcDET_SPRICE = parseFloat(PROPRICE.price) == 0 ? parseFloat(FormRow.dcDET_SPRICE_OLD).toFixed(txnDecimalAmt) : parseFloat(PROPRICE.price).toFixed(txnDecimalAmt)
                                            newRow.dcDET_DISCAMT = parseFloat(PROPRICE.discAmt).toFixed(txnDecimalAmt)
                                            newRow.dcDET_DISCPER = parseFloat(PROPRICE.discPer).toFixed(2)
                                        } else { //if product price is not available then set the old price
                                            newRow.dcDET_SPRICE = FormRow.dcDET_SPRICE_OLD
                                        }
                                    }
                                    if (balanceResponse) {
                                        LineAmtCalcualtion(unti, FormRow.dcDET_CASEQTY, newRow.dcDET_DISCPER, newRow.dcDET_DISCAMT)
                                    } else {
                                        LineAmtCalcualtion(0, FormRow.dcDET_CASEQTY, newRow.dcDET_DISCPER, newRow.dcDET_DISCAMT)
                                    }

                                }}
                                onKeyPress={e => {
                                    KeyPressEvnt(e, Key)
                                }}
                            ></DPTextBoxforgrid>
                        </Col>
                    </Row>
                </td >) : null}
            {txn.intTX_FREEUNITQTY == 1 ? (
                <td style={{ width: parseInt(profreeunit.width) }}>
                    <Row className="mb-0">
                        <Col md="12">
                            <DPTextBoxforgrid
                                rowClass="mb-12-sm"
                                labelText=""
                                textType="text"
                                maxLength={profreeunit.len}
                                id={'V_' + profreeunit.name + Key}
                                textAlign={'right'}
                                value={FormRow.dcDET_FUNITQTY}
                                disabled={funitQtyDisable}
                                onChange={e => {
                                    let txt = 0
                                    if (FormRow.isDecimal == 1) {
                                        txt = Numeric(e.target, 18, txnDecimalQty, false)
                                    } else {
                                        txt = Numeric(e.target, 18, 0, false)
                                    }

                                    if (e.target.value == "") {
                                        txt = 0;
                                    }

                                    changeObjectValue(txt, FormRow.id, "dcDET_FUNITQTY")
                                }}
                                onBlur={(e) => {
                                    let enteredValue = e.target.value
                                    if (e.target.value == "") {
                                        enteredValue = 0;
                                    }

                                    if ((txn.intTX_FREEQTYMINUS == 1 || txn.intTX_VERIFICATION == 1) && txn.intTX_BOM == 0) {
                                        enteredValue = Math.abs(enteredValue) * -1;
                                    }

                                    LineAmtCalcualtion(FormRow.dcDET_UNITQTY, FormRow.dcDET_CASEQTY, FormRow.dcDET_DISCPER, FormRow.dcDET_DISCAMT, 0, enteredValue)

                                }}
                                onKeyPress={e => {
                                    KeyPressEvnt(e, Key)
                                }}
                            ></DPTextBoxforgrid>
                        </Col>
                    </Row>
                </td >) : null}
            {txn.intTX_FREECASEQTY == 1 ? (
                <td style={{ width: parseInt(profreecase.width) }}>
                    <Row className="mb-0">
                        <Col md="12">
                            <DPTextBoxforgrid
                                rowClass="mb-12-sm"
                                labelText=""
                                textType="text"
                                maxLength={profreecase.len}
                                id={'V_' + profreecase.name + Key}
                                textAlign={'right'}
                                value={FormRow.dcDET_FCASEQTY}
                                disabled={fcaseQtyDisable}
                                onChange={e => {
                                    let txt = 0
                                    if (FormRow.isDecimal == 1) {
                                        txt = Numeric(e.target, 18, txnDecimalQty, false)
                                    } else {
                                        txt = Numeric(e.target, 18, 0, false)
                                    }

                                    if (e.target.value == "") {
                                        txt = 0;
                                    }

                                    changeObjectValue(txt, FormRow.id, "dcDET_FCASEQTY")
                                }}
                                onKeyPress={e => {
                                    KeyPressEvnt(e, Key)
                                }}
                            ></DPTextBoxforgrid>
                        </Col>
                    </Row>
                </td >) : null}
            {txn.intTX_LINEDISCPER == 1 ? (
                <td style={{ width: parseInt(prodiscper.width) }}>
                    <Row className="mb-0">
                        <Col md="12">
                            <DPTextBoxforgrid
                                rowClass="mb-12-sm"
                                labelText=""
                                textType="text"
                                maxLength={prodiscper.len}
                                id={'V_' + prodiscper.name + Key}
                                textAlign={'right'}
                                value={FormRow.dcDET_DISCPER}
                                disabled={discperDisable}
                                onChange={e => {
                                    let txt = Numeric(e.target, 18, txnDecimalAmt, false)
                                    if (parseFloat(txt) <= 100) {
                                        //setdiscPer(txt)
                                        changeObjectValue(txt, FormRow.id, "dcDET_DISCPER")
                                    }

                                }}
                                onBlur={(e) => LineAmtCalcualtion(FormRow.dcDET_UNITQTY, FormRow.dcDET_CASEQTY, e.target.value, FormRow.dcDET_DISCAMT)}
                                onKeyPress={e => {
                                    KeyPressEvnt(e, Key)
                                }}
                            ></DPTextBoxforgrid>
                        </Col>
                    </Row>
                </td >) : null}
            {txn.intTX_LINEDISCAMT == 1 ? (
                <td style={{ width: parseInt(prodiscamt.width) }}>
                    <Row className="mb-0">
                        <Col md="12">
                            <DPTextBoxforgrid
                                rowClass="mb-12-sm"
                                labelText=""
                                textType="text"
                                maxLength={prodiscamt.len}
                                id={'V_' + prodiscamt.name + Key}
                                textAlign={'right'}
                                value={FormRow.dcDET_DISCAMT}
                                disabled={discperDisable}
                                onChange={e => {
                                    let txt = Numeric(e.target, 18, txnDecimalAmt, false, true)
                                    if (e.target.value == "") {
                                        txt = 0;
                                    }
                                    changeObjectValue(txt, FormRow.id, "dcDET_DISCAMT")
                                }}
                                onBlur={(e) => {
                                    let txt = e.target.value

                                    if (e.target.value == "") {
                                        txt = 0;
                                    }

                                    LineAmtCalcualtion(FormRow.dcDET_UNITQTY, FormRow.dcDET_CASEQTY, FormRow.dcDET_DISCPER, txt)
                                }}
                                onKeyPress={e => {
                                    KeyPressEvnt(e, Key)
                                }}
                            ></DPTextBoxforgrid>
                        </Col>
                    </Row>
                </td >) : null}
            {txn.intTX_HIDEPRICES == 0 ? (
                <td style={{ width: parseInt(proamt.width) }}>
                    <Row className="mb-0">
                        <Col md="12">
                            <DPTextBoxforgrid
                                rowClass="mb-12-sm"
                                labelText=""
                                textType="text"
                                maxLength={proamt.len}
                                id={'V_' + proamt.name + Key}
                                textAlign={'right'}
                                value={FormRow.dcDET_AMOUNT}
                                disabled={true}
                                onChange={e => {
                                    let txt = Numeric(e.target, 18, txnDecimalAmt, false)
                                    changeObjectValue(txt, FormRow.id, "dcDET_AMOUNT")
                                }}
                                onKeyPress={e => {
                                    KeyPressEvnt(e, Key)
                                }}
                            ></DPTextBoxforgrid>
                        </Col>
                    </Row>
                </td >) : null}
            {txn.intTX_LINEREMARKS == 1 ? (
                <td style={{ width: parseInt(proremark.width) }}>
                    <Row className="mb-0">
                        <Col md="12">

                            <DPDropDown
                                rowClass="mb-4-sm"
                                labelText=""
                                optionGroup={reasonTypes}
                                selectedGroup={FormRow.strDET_REMCODE}
                                disabled={remcodeDisable}
                                onChange={(e) => {
                                    changeObjectValue(e["value"], FormRow.id, "strDET_REMCODE")
                                }}
                                id={"txtremarks"}
                                inputId={proremark.name + Key}
                                onKeyPress={e => {
                                    KeyPressEvnt(e)
                                }}
                                labelHide={true}
                            />
                        </Col>
                    </Row>
                </td >) : null}

            {/* <td>
                {FormRow.id}
            </td> */}

            <DPAlert
                confirm_both={sweetAlertShow}
                title={txn.strTX_DESC}
                description={AlertDescription}
                showCancel={false}
                btnColor={"success"}
                cancelColor={"danger"}
                onConfirm={() => {
                    setsweetAlertShow(false)

                }}
                btnYes={"OK"}
            />
        </tr>
    )
}
//* end Single Row for TXN Details table */